import React, { Component } from 'react';
import bgvideo from './video/DSC_2547_h264_480sd.mp4'
import loadingimg from './images/loading_image_v2_purple.png'




class Background extends Component {


    constructor(props) {
      super(props);
        this.checkTime = this.checkTime.bind(this)
        this.state = { 
            currentVideoTime: 0,
            video: null
        }
      
    }

    checkTime(){
        //console.log("time updated:"+this.state.video.currentTime)
        if(this.state.video.currentTime > 12.5) {
                console.log("event was reached")
             clearInterval(this.timer)
        }
    }

    componentDidMount (){
        var videoInfo = document.getElementsByTagName("video")[0];
        this.setState({video:videoInfo})

        //videoInfo.addEventListener("seeked", function() { videoInfo.play(); }, true);
        //videoInfo.addEventListener("timeupdate", this.checkTime());
        //videoInfo.currentTime = 10.0;
        
        this.timer = setInterval(() => this.checkTime(), 1000);
    }
    componentWillUnmount() {
    // This method is called immediately before the component is removed
    // from the page and destroyed. We can clear the interval here:

    clearInterval(this.timer)

    }

    

  render() {

    return (

    	<div className="bgContainer">
        <div className="videoloadbg"></div>
    	<video id="video-background" src={bgvideo} autoPlay loop muted playsInline></video>
		</div>
    	  )
  }
}

export default Background;


// WEBPACK FOOTER //
// ./src/Background.js